export default Object.freeze({
  POSTNORD: "POSTNORD",
  POSTI: "POSTI",
});
